import Phaser from 'phaser';

type Direction = 'left' | 'right' | 'up' | 'down' | 'none';

export class KeyboardInput {
  private currentDirection: Direction = 'none';
  private readonly scene: Phaser.Scene;
  private readonly handlers: Array<{ event: string; fn: () => void }> = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.setupKeys();
  }

  getDirection(): Direction {
    return this.currentDirection;
  }

  destroy(): void {
    const keyboard = this.scene.input.keyboard;
    if (!keyboard) {
      return;
    }
    for (const { event, fn } of this.handlers) {
      keyboard.off(event, fn);
    }
    this.handlers.length = 0;
    this.currentDirection = 'none';
  }

  private addKeyHandler(event: string, direction: Direction): void {
    const fn = (): void => {
      this.currentDirection = direction;
    };
    this.handlers.push({ event, fn });
    this.scene.input.keyboard?.on(event, fn);
  }

  private setupKeys(): void {
    if (!this.scene.input.keyboard) {
      return;
    }

    this.addKeyHandler('keydown-LEFT', 'left');
    this.addKeyHandler('keydown-A', 'left');
    this.addKeyHandler('keydown-RIGHT', 'right');
    this.addKeyHandler('keydown-D', 'right');
    this.addKeyHandler('keydown-UP', 'up');
    this.addKeyHandler('keydown-W', 'up');
    this.addKeyHandler('keydown-DOWN', 'down');
    this.addKeyHandler('keydown-S', 'down');
  }
}
